import type { CartEvaluationItemInputWire } from 'businessTraveller/api/requestPostCartEvaluation'

// Shared inputs for building each cart evaluation line
export type CartLineContext = {
  currencyCode: string
  selectedEmployeeIds: Array<string>
  selectedGuestCount: number
  travellerCount: number
}

type CartEvaluationTraveller = CartEvaluationItemInputWire['travellers'][number]

// Travellers of a cart line: the room occupancy when set (hotel/bedbank), otherwise every selected traveller
export function resolveCartLineTravellers(
  context: CartLineContext,
  occupancy?: App.Occupants,
): Array<CartEvaluationTraveller> {
  const occupantEmployeeIds = occupancy?.employeeIds ?? []
  const occupantGuestIds = occupancy?.guestIds ?? []
  const hasRoomOccupancy = occupantEmployeeIds.length > 0 || occupantGuestIds.length > 0

  const employeeIds = hasRoomOccupancy ? occupantEmployeeIds : context.selectedEmployeeIds
  const guestCount = hasRoomOccupancy ? occupantGuestIds.length : context.selectedGuestCount

  const travellers: Array<CartEvaluationTraveller> = [
    ...employeeIds.map((employeeId) => ({ employeeId, isPrimaryTraveller: false })),
    ...Array.from({ length: guestCount }, () => ({ employeeId: undefined, isPrimaryTraveller: false })),
  ]

  // The endpoint requires at least one traveller per line
  if (travellers.length === 0) {
    travellers.push({ employeeId: undefined, isPrimaryTraveller: false })
  }

  travellers[0].isPrimaryTraveller = true
  return travellers
}
